import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import logo from "./assets/featherglass-sq-logo.png";
import CircularProgress from "@mui/material/CircularProgress";

const REASON_MESSAGES = {
  expired: "This invitation has expired. Please ask the sender to resend it.",
  already_used: "This invitation has already been used. Sign in with the email address you used to create your account.",
  revoked: "This invitation has been revoked by the sender.",
  not_found: "This invitation link is invalid or no longer exists.",
  error: "Something went wrong while validating this invitation. Please try again.",
};

const InviteAccept = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | redirecting | error
  const [reason, setReason] = useState(null);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setReason("not_found");
      return;
    }

    const validateToken = async () => {
      try {
        const response = await fetch(`/api/invitations/validate/${token}`);
        const data = await response.json();

        if (data.valid) {
          setStatus("redirecting");
          navigate(`/signup?invite=${token}`, { replace: true });
        } else {
          setStatus("error");
          setReason(data.reason || "not_found");
        }
      } catch (error) {
        console.error("Invite validation error:", error);
        setStatus("error");
        setReason("error");
      }
    };

    validateToken();
  }, [token, navigate]);

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className="logo-login" />

      {status === "loading" && (
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <CircularProgress size={40} />
          <p style={{ marginTop: "16px", color: "var(--color-text-light)" }}>
            Validating your invitation...
          </p>
        </div>
      )}

      {status === "redirecting" && (
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <CircularProgress size={40} />
          <p style={{ marginTop: "16px", color: "var(--color-text-light)" }}>
            Redirecting to signup...
          </p>
        </div>
      )}

      {status === "error" && (
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <h3 className="title">Invitation Unavailable</h3>
          <p style={{ color: "var(--color-text-light)", marginBottom: "24px" }}>
            {REASON_MESSAGES[reason] || REASON_MESSAGES.not_found}
          </p>
          <Link to="/" className="center-button primary" style={{ display: "inline-block", textDecoration: "none" }}>
            Sign in
          </Link>
          {reason !== 'already_used' && (
            <p style={{ marginTop: "16px" }}>To create an account, ask the sender for a new invitation.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default InviteAccept;
